export default __webpack_public_path__ + "45234c5abfacca3c10912626eeff81cf.jpg";